"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import taskMap from "@/configuration/taskMap";
import API from "@ym-framework/api-utils";
import OSS from "ali-oss";
const UUID = require("uuid");
export class UploadTask {
  constructor(file, id, type) {
    // 类型
    this.type = "shop";
    // 文件路径
    this.path = "";
    // ossid
    this.ossId = "";
    // 更新时间
    this.updateTime = 0;
    this.fileType = "local";
    this.file = file;
    this.progress = 0;
    this.state = taskMap.await;
    this.shopId = id;
    this.name = file.name;
    this.keyId = `${Math.random()}${Date.now()}${Math.random()}`;
    this.updateTime = Date.now().valueOf();
    this.speed = "0";
    this.type = type;
  }
}
export class UploadVDManagerWrap {
  // 上传数量是否超过限制
  constructor() {
    //当前oss实例
    this.queueTask = [];
    //当前传输任务
    this.historyTaskSuccess = [];
    //历史传输成功
    this.historyTaskError = [];
    //历史传输失败
    this.beUpload = false;
    //是否正在上传中
    this.refreshFileList = false;
    // 临时授权
    this.maxUploadSize = 1e7;
    //单文件最大上传大小
    this.maxUploadFileNumber = 3;
    //最大上传数量
    this.remainingSpace = 1e7;
    // 剩余空间
    this.currentFileTotalSize = 0;
    // 当前任务管理器的空间
    this.errorPrompt = false;
    //是否弹出错误提示
    this.isUploadSuccessVd = false;
    // 是否成功上传
    this.isOverSize = false;
    //
    this.isMaxSize = false;
    this.queueTask = [];
    this.historyTaskSuccess = [];
    this.historyTaskError = [];
    this.beUpload = false;
  }
  //总任务数
  get allTaskLen() {
    return this.historyTaskSuccess.length + this.queueTask.length + this.historyTaskError.length;
  }
  //队列任务数
  get queueTaskLen() {
    return this.queueTask.length;
  }
  //失败任务数
  get TaskErrorLen() {
    return this.historyTaskError.length;
  }
  //添加任务
  add(tasks) {
    console.log("\u6DFB\u52A0\u4E86\u4EFB\u52A1\uFF1A" + tasks[0].file.size);
    console.log(
      this.queueTask.length,
      this.historyTaskSuccess.length,
      this.maxUploadFileNumber,
      "\u961F\u5217\u6570\u91CF"
    );
    console.log(this.queueTask.length, this.historyTaskSuccess.length);
    if (tasks[0].file.size > this.maxUploadSize) {
      console.log("\u8D85\u8FC7\u6700\u5927\u4E0A\u4F20\u5927\u5C0F");
      this.errorPrompt = true;
      return;
    }
    this.currentFileTotalSize += tasks[0].file.size;
    if (this.currentFileTotalSize > this.remainingSpace) {
      console.log("\u8D85\u8FC7\u6700\u5927\u4E0A\u4F20\u7A7A\u95F4");
      this.isOverSize = true;
      return;
    }
    if (
      // this.queueTask.length + this.historyTaskSuccess.length + 1 >
      this.queueTask.length + 1 > this.maxUploadFileNumber
    ) {
      console.log("\u8D85\u8FC7\u6700\u5927\u4E0A\u4F20\u6570\u91CF");
      this.isMaxSize = true;
      return;
    }
    this.queueTask.unshift(...tasks);
    if (!this.beUpload) {
      this.start();
    }
  }
  //启动任务
  start() {
    return __async(this, null, function* () {
      console.log("\u4EFB\u52A1\u542F\u52A8");
      if (this.queueTask.length === 0) {
        this.beUpload = false;
        this.refreshFileList = true;
        return false;
      }
      this.beUpload = true;
      this.refreshFileList = false;
      this.currentTask = this.queueTask[0];
      if (this.currentTask.state !== taskMap.await) {
        this.uploadError();
        return false;
      }
      this.currentTask.state = taskMap.running;
      this.preUpload();
    });
  }
  //预上传请求
  preUpload() {
    return __async(this, null, function* () {
      if (this.tmpAuth) {
        yield this.uploadToAliOss(this.tmpAuth);
      } else {
        yield this.getTmpAuth();
        yield this.uploadToAliOss(this.tmpAuth);
      }
    });
  }
  noticeVDUpload() {
    return __async(this, null, function* () {
      if (this.currentTask.type === "vd" && this.currentTask.message !== "\u5DF2\u53D6\u6D88") {
        yield this.uploadToVD();
      }
    });
  }
  // 上传到VD的附件
  uploadToVD() {
    return __async(this, null, function* () {
      var _a;
      console.log("\u4E0A\u4F20\u5230VD");
      try {
        yield API.post(
          `api://base.auth/api/v8/virtual_desktops/${(_a = this.currentTask) == null ? void 0 : _a.shopId}/files`,
          {
            file_uid: this.currentTask.ossId,
            // 单个传
            files: [
              {
                file_path: this.currentTask.path,
                file_real_name: this.currentTask.file.name
              }
            ]
          }
        );
      } catch (error) {
      }
    });
  }
  // 获取临时授权
  getTmpAuth() {
    return __async(this, null, function* () {
      var _a, _b;
      console.log("\u83B7\u53D6\u4E34\u65F6\u6388\u6743", (_a = this.currentTask) == null ? void 0 : _a.shopId);
      try {
        const response = yield API.get("api://base.auth/api/v7/file/sts", {
          params: {
            type: "vd",
            id: (_b = this.currentTask) == null ? void 0 : _b.shopId
          }
        });
        this.tmpAuth = response.data.data;
      } catch (error) {
        this.currentTask.message = error.response.data.errors.datas[0].message;
        this.uploadError();
      }
    });
  }
  //任务开始传输
  uploadToAliOss(data) {
    return __async(this, null, function* () {
      var _a;
      console.log(data, "\u4E34\u65F6\u6388\u6743\u6570\u636E");
      try {
        this.client = new OSS({
          region: "oss-cn-beijing",
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        let random = UUID.v4();
        this.currentTask.path = data.path + "/" + random;
        this.currentTask.ossId = data.id;
        let percent = ((_a = this.currentTask) == null ? void 0 : _a.file.size) / 100;
        let time = Date.now();
        let lastProgress = 0;
        yield this.client.multipartUpload(
          data.path + "/" + random,
          this.currentTask.file,
          {
            progress: (p, cpt) => {
              this.abortCheckpoint = cpt;
              this.currentTask.progress = p * 100;
              if (Date.now() - time >= 800) {
                this.currentTask.speed = this.transform(
                  +(p * 100 - lastProgress).toFixed(2) * percent
                );
                time = Date.now();
                lastProgress = p * 100;
              }
            }
          }
        );
        this.uploadSuccess();
      } catch (error) {
        console.log("\u4E0A\u4F20\u5931\u8D25", error);
        this.uploadError();
      }
    });
  }
  //传输成功
  uploadSuccess() {
    return __async(this, null, function* () {
      yield this.noticeVDUpload();
      console.log("\u4E0A\u4F20\u5B8C\u6210");
      this.currentTask.state = taskMap.success;
      this.isUploadSuccessVd = true;
      this.queueTask.shift();
      this.historyTaskSuccess.unshift(this.currentTask);
      console.log(this.historyTaskSuccess, "\u5386\u53F2\u6210\u529F");
      this.start();
    });
  }
  //传输失败
  uploadError() {
    this.currentTask.state = taskMap.error;
    this.historyTaskError.unshift(this.currentTask);
    this.start();
  }
  // 清除任务队列
  clearQueue() {
    console.log("\u6E05\u9664\u4EFB\u52A1\u961F\u5217");
    this.queueTask = [];
    this.currentFileTotalSize = 0;
  }
  // 删除当前任务
  removeCurrentTask(item) {
    console.log("\u5220\u9664\u5F53\u524D\u4EFB\u52A1", item);
    this.queueTask = this.queueTask.filter((task) => task.keyId !== item.keyId);
  }
  //取消当前任务传输
  cancelCurrentUpload(row) {
    if (!this.abortCheckpoint) {
      return false;
    }
    this.client.abortMultipartUpload(
      this.abortCheckpoint.name,
      this.abortCheckpoint.uploadId
    );
    this.abortCheckpoint = null;
    this.currentTask.message = "\u5DF2\u53D6\u6D88";
    row && this.removeCurrentTask(row);
  }
  //清空传输失败记录
  emptyTaskError() {
    this.historyTaskError = [];
  }
  //清空传输成功记录
  emptyTaskSuccess() {
    this.historyTaskSuccess = [];
  }
  //大小转换
  transform(byte) {
    if (byte > 1024 * 1024) {
      return `${(byte / 1024 / 1024).toFixed(2)}MB`;
    }
    if (byte > 1024) {
      return `${(byte / 1024).toFixed(2)}KB`;
    }
    return `${byte.toFixed(2)}B`;
  }
}
